<template>
  <div class="p-6">
    <header class="flex items-center justify-start flex-wrap space-x-4 mb-12">
      <img class="h-24 w-24 rounded-full" 
      src="https://ucarecdn.com/96bd5197-1b63-4648-9cd0-101807cb2cea/sakura.JPG">

      <div class="w-2/3">
        <h1 class="mb-2">{{ user.first_name }} {{ user.last_name }}</h1>
        <p>
          {{ user.bio }}
        </p>
      </div>
    </header>

    <main>
       <!-- <button v-if="!showForm" @click="showForm = true" class="btn">
        Edit Profile
      </button> -->
      <!-- <div v-if="showForm"> -->
        <el-form ref="form">
          <el-form-item label="First Name">
            <el-input
              placeholder="Please input"
              v-model="user.first_name"
            ></el-input>
          </el-form-item>

          <el-form-item label="Last Name">
            <el-input
              placeholder="Please input"
              v-model="user.last_name"
            ></el-input>
          </el-form-item>

          <el-form-item label="bio">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Please input"
              v-model="user.bio"
            >
            </el-input>
          </el-form-item>

          <button @click="saveProfile()" class="btn">Save</button>
        </el-form>
      <!-- </div> -->
    </main>
  </div>
</template>


<script>
import { db } from "@/db";
export default {
  data: function () {
    return {
      user: {},
      // showForm: false,
      user_id: "dhBpZODtRIO119cIpdBD",
    };
  },
  mounted() {
    // go get the current user based on id from firbase
    db.collection("users")
      .doc(this.user_id)
      .get()
      .then((snapshot) => {
        this.user = snapshot.data();
      });
  },
  methods: {
    saveProfile() {
      console.log(this.user);
      db.collection("users")
        .doc(this.user_id)
        .set(this.user)
        .then(() => {
          console.log("user updated!");

          this.showForm = false;

          // alert the message
          this.$message({
            message: "Your profile is updated",
            type: "success",
          });
        });
    },
  },
};
</script>


<style>

body {
    background: #654ea3;
    background: linear-gradient(to right, #f0b6ff,#78cac3,#9cd6f8);
    min-height: 100vh
}

</style>